require("regenerator-runtime/runtime");
/**
 * Function to swap the source with the mobile source if available.
 * @param {any} $video The video element for which the video should be swapped
 * @param {any} isMobile Condition to detect screen size
 * @returns
 */
export default async function swapVideoSource($video, isMobile = true) {
    //Get primary source of video's first source.
    const FirstSource = $video?.find('source:first')?.attr("src")
    if (!(FirstSource && typeof FirstSource === "string")) return console.log("Error getting current source.") && false;

    //If desktop, just trigger primary source.
    if (!isMobile) return $video.attr("src", FirstSource) && false;

    //Is this already mobile?
    if (FirstSource.substr(0, FirstSource.length - 4).substr(-7, 7) == "-mobile") return console.log("We already have the mobile version of the video") && false;

    //Get mobile Url
    const MobileUrl = FirstSource.substr(0, FirstSource.length - 4) + "-mobile.mp4";
    if (!MobileUrl) return console.log("Couldn't evaluate mobile video url.") && false;

    //HEAD the request to sniff if it is there.
    var request = await fetch(MobileUrl, { method: "HEAD" })

    //Is it there?
    if (request.status != 200 && request.headers.get("content-type") != "video/mp4") return console.log("Couldn't find the mobile video, check response.") && false;

    //Write the valid URL to the source.
    $video.attr("src", MobileUrl);
    return FirstSource
}